import { ServiceReport } from '~/features/ServiceReport';

export const Screen: React.FC = () => <ServiceReport />;
